// ─── Collateral Tokens ───────────────────────────────────────────────────────
// V1: USDC.e (kept for legacy balance reads / wrapping reference)
export const USDC_E_CONTRACT_ADDRESS = '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174' as const;
export const USDC_E_DECIMALS = 6;

// Native USDC on Polygon (Circle CCTP — sent by Coinbase Onramp and most exchanges in 2024+)
export const NATIVE_USDC_CONTRACT_ADDRESS = '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359' as const;
export const NATIVE_USDC_DECIMALS = 6;

// V2: pUSD — Polymarket USD (new trading collateral from April 28, 2026)
export const PUSD_CONTRACT_ADDRESS = '0xC011a7E12a19f7B1f670d46F03B03f3342E82DFB' as const;
export const PUSD_DECIMALS = 6;

// Collateral Onramp: wrap USDC.e → pUSD via wrap(address asset, address to, uint256 amount)
export const COLLATERAL_ONRAMP_ADDRESS = '0x93070a847efEf7F70739046A929D47a521F5B8ee' as const;

// Collateral Offramp: unwrap pUSD → USDC.e via unwrap(address underlyingToken, address recipient, uint256 amount)
export const COLLATERAL_OFFRAMP_ADDRESS = '0x2957922eb93258b93368531d39facca3b4dc5854' as const;

// ─── CTF / Exchange Contracts ─────────────────────────────────────────────────
// Conditional Token Framework (unchanged)
export const CTF_CONTRACT_ADDRESS = '0x4D97DCd97eC945f40cF65F87097ACe5EA0476045' as const;

// V2 Exchange addresses (updated April 28, 2026)
export const CTF_EXCHANGE_ADDRESS = '0xE111180000d2663C0091e4f400237545B87B996B' as const;
export const NEG_RISK_CTF_EXCHANGE_ADDRESS = '0xe2222d279d744050d28e00520010520000310F59' as const;

// Neg Risk Adapter (unchanged)
export const NEG_RISK_ADAPTER_ADDRESS = '0xd91E80cF2E7be2e162c6513ceD06f1dD0dA35296' as const;

// Collateral Adapters (added for V2 redeem, split, merge actions wrapping pUSD)
export const CTF_COLLATERAL_ADAPTER_ADDRESS = '0xAdA100Db00Ca00073811820692005400218FcE1f' as const;
export const NEG_RISK_CTF_COLLATERAL_ADAPTER_ADDRESS =
  '0xadA2005600Dec949baf300f4C6120000bDB6eAab' as const;

// ─── Gnosis Safe / Proxy Contracts ───────────────────────────────────────────
// Polymarket Safe Factory on Polygon
export const SAFE_FACTORY_ADDRESS = '0xaacFeEa03eb1561C4e67d661e40682Bd20E3541b' as const;
export const SAFE_INIT_CODE_HASH =
  '0x2bce2127ff07fb632d16c8347c4ebf501f4841168bed00d9e6ef715ddb6fcecf' as const;
